import { render, staticRenderFns } from "./AdditionalItems.vue?vue&type=template&id=57a7ff64&scoped=true&"
import script from "./AdditionalItems.vue?vue&type=script&lang=js&"
export * from "./AdditionalItems.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalItems.vue?vue&type=style&index=0&id=57a7ff64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a7ff64",
  null
  
)

export default component.exports